const faqs = [
  {
    question: "Does Minnesota have its own passport agency?",
    answer:
      "Minnesota does not have a state-level passport agency. The nearest regional passport agency for most Minnesota residents is the Chicago Passport Agency, located in downtown Chicago. The Detroit Passport Agency is also within reasonable driving distance for residents in the eastern part of the state.",
  },
  {
    question: "How fast can I get a passport in Minnesota?",
    answer:
      "With Fast Passport Center's courier service, Minnesota travelers can receive a passport in as little as 24 hours. Our standard expedited service ranges from 3 to 9 business days. Routine processing through the post office typically takes 6 to 13 weeks.",
  },
  {
    question: "Do I need to visit a passport acceptance facility in Minnesota?",
    answer:
      "First-time applicants, minors, and those replacing lost or stolen passports must visit an acceptance facility (typically a post office, county clerk, or public library). Renewals for adults can usually be done by mail without an in-person visit.",
  },
  {
    question: "Which Minnesota airport should I fly from with an expired passport?",
    answer:
      "If your passport is expired or soon to expire, you should not book international travel until you have a valid passport in hand. Major Minnesota international departure points are Minneapolis-Saint Paul International (MSP), with direct flights to Europe, Asia, Canada, and Mexico. Duluth (DLH) and Rochester (RST) also offer international connections.",
  },
  {
    question: "Can I renew my passport by mail in Minnesota?",
    answer:
      "Yes, if your most recent passport was issued when you were 16 or older, is undamaged, was issued within the last 15 years, and has your current name (or you can document a name change). Minnesota residents can mail renewal applications to the National Passport Processing Center.",
  },
  {
    question: "What documents do I need for a first-time passport in Minnesota?",
    answer:
      "You'll need Form DS-11, proof of U.S. citizenship (certified birth certificate or naturalization certificate), a valid photo ID (driver's license or state ID), a passport photo, and payment for fees. All documents must be submitted in person at an acceptance facility.",
  },
];

export { faqs };

export default function MinnesotaFAQSection() {
  return (
    <section id="faq" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-3xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">FAQ</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Minnesota Passport Questions
          </h2>
          <p className="text-gray-500 text-base leading-relaxed">
            Quick answers for travelers applying for passports across the state of Minnesota.
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, i) => (
            <details
              key={i}
              className="group bg-white rounded-lg border border-gray-200 overflow-hidden"
            >
              <summary className="flex items-center justify-between cursor-pointer p-5 list-none">
                <span className="font-bold text-[#1A365D] text-sm pr-4">{faq.question}</span>
                <div className="w-7 h-7 flex items-center justify-center rounded-full bg-[#EEF2F8] flex-shrink-0">
                  <i className="ri-add-line text-[#1A365D] text-sm group-open:ri-subtract-line"></i>
                </div>
              </summary>
              <div className="px-5 pb-5">
                <p className="text-gray-500 text-sm leading-relaxed">{faq.answer}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}